import {Checkbox, FormControlLabel, Grid, Typography} from "@material-ui/core";
import React from "react";

export default function NotExpiringTodayCheckBox({notExpiringToday, setNotExpiringToday}) {
    return (<FormControlLabel
        control={
            <Checkbox
                checked={notExpiringToday}
                onChange={(ev) => setNotExpiringToday(ev.target.checked)}
                name="not expiring today"
            />
        }
        style={{width: 100}}
        label={<Typography style={{fontSize: 10}}>not expiring today</Typography>}
        labelPlacement={"start"}
    />);
}